import { ChainId, renderToPlainText, truncateDescription } from "common";
import { getDaysLeft, votingTokens } from "../api/utils";
import { BasicCard, CardContent, CardDescription, CardHeader, CardTitle } from "../common/styles";
import RoundBanner from "./RoundBanner";
import RoundCardStat from "./RoundCardStat";
import { useToken } from "wagmi";
import { getAddress } from "viem";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RoundCard = props => {
  var _nativePayoutToken$na, _props$round$projects, _props$round$projects2, _props$round$roundMet, _props$round$roundMet2, _props$round$roundMet3, _tokenData$symbol;
  const daysLeft = getDaysLeft(Number(props.round.roundEndTime));
  const chainIdEnumValue = ChainId[props.round.chainId];
  const {
    data
  } = useToken({
    address: getAddress(props.round.token),
    chainId: Number(props.round.chainId)
  });
  const nativePayoutToken = votingTokens.find(t => t.chainId === chainIdEnumValue && t.address === getAddress(props.round.token));
  const tokenData = data !== null && data !== void 0 ? data : {
    ...nativePayoutToken,
    symbol: (_nativePayoutToken$na = nativePayoutToken === null || nativePayoutToken === void 0 ? void 0 : nativePayoutToken.name) !== null && _nativePayoutToken$na !== void 0 ? _nativePayoutToken$na : "ETH"
  };
  const approvedApplicationsCount = (_props$round$projects = (_props$round$projects2 = props.round.projects) === null || _props$round$projects2 === void 0 ? void 0 : _props$round$projects2.length) !== null && _props$round$projects !== void 0 ? _props$round$projects : 0;
  return /*#__PURE__*/_jsxs(BasicCard, {
    className: "w-full",
    children: [/*#__PURE__*/_jsxs("a", {
      target: "_blank",
      href: `/#/round/${chainIdEnumValue}/${props.round.id}`,
      "data-testid": "round-card",
      children: [/*#__PURE__*/_jsx(CardHeader, {
        children: /*#__PURE__*/_jsx(RoundBanner, {
          roundId: props.round.id
        })
      }), /*#__PURE__*/_jsxs(CardContent, {
        children: [/*#__PURE__*/_jsx(CardTitle, {
          "data-testid": "round-name",
          children: (_props$round$roundMet = props.round.roundMetadata) === null || _props$round$roundMet === void 0 ? void 0 : _props$round$roundMet.name
        }), /*#__PURE__*/_jsx(CardDescription, {
          "data-testid": "round-description",
          className: "h-[90px]",
          children: truncateDescription(renderToPlainText((_props$round$roundMet2 = (_props$round$roundMet3 = props.round.roundMetadata) === null || _props$round$roundMet3 === void 0 ? void 0 : _props$round$roundMet3.eligibility.description) !== null && _props$round$roundMet2 !== void 0 ? _props$round$roundMet2 : ""), 240)
        }), /*#__PURE__*/_jsxs("p", {
          className: "mt-4 text-xs",
          "data-testid": "days-left",
          children: [daysLeft, " ", daysLeft === 1 ? "day" : "days", " left in round"]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "bg-white",
      children: [/*#__PURE__*/_jsx("div", {
        className: "border-t w-11/12 ml-4"
      }), /*#__PURE__*/_jsx(CardContent, {
        className: "text-xs mt-3 pb-0",
        children: /*#__PURE__*/_jsx(RoundCardStat, {
          chainId: Number(chainIdEnumValue),
          matchAmount: props.round.matchAmount,
          token: (_tokenData$symbol = tokenData === null || tokenData === void 0 ? void 0 : tokenData.symbol) !== null && _tokenData$symbol !== void 0 ? _tokenData$symbol : "...",
          approvedApplicationsCount: approvedApplicationsCount
        })
      })]
    })]
  });
};
export default RoundCard;